import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const LogoStrip = ({ logos = [] }) => {
  if (!logos || logos.length === 0) {
    return null;
  }

  return (
    <div className={styles.logoStrip}>
      {logos?.map((logo, index) => (
        <div key={index} className={styles.logoItem}>
          <img src={logo.sizes?.medium?.url || logo.url} alt={logo.title || ''} />
        </div>
      ))}
    </div>
  );
};


LogoStrip.propTypes = {
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string,
      sizes: PropTypes.shape({
        thumbnail: PropTypes.shape({
          url: PropTypes.string,
        }),
        medium: PropTypes.shape({
          url: PropTypes.string,
        }),
        large: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    })
  ),
};

export default LogoStrip;
